import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { SubscriptionInfo } from '@models/user/subscription-info/subscription-info';

import { HttpService } from 'src/app/services/http.service';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class PlansInfoService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private subscriptionSubject = new BehaviorSubject<SubscriptionInfo>(new SubscriptionInfo());
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);

    private dataStore: { subscriptionInfo: SubscriptionInfo } = { subscriptionInfo: new SubscriptionInfo() };

    readonly subscriptionInfo = this.subscriptionSubject.asObservable();
    readonly loadingData = this.isLoadingDataSubject.asObservable();

    search(): void {
        this.loading(true);
        this.getSubscription().subscribe(
            () => {
                this.next(this.dataStore.subscriptionInfo);
                this.loading(false);
            }
        );
    }

    searchSubscription(): Observable<any> {
        return this.get('subscription/member/plan/member', this.defaultEndpointParams);
    }

    private getSubscription(): Observable<boolean> {
        return new Observable<boolean>(
            observable => {
                this.searchSubscription().subscribe(
                    data => {
                        this.dataStore.subscriptionInfo = new SubscriptionInfo().build(data);
                        observable.next(true);
                    },
                    () => observable.next(false)
                );
            }
        );
    }

    private next(data: SubscriptionInfo): void {
        this.subscriptionSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
